import {
    SCREEN_NAME,
    IMPRESSION_ACTIONS,
    CLICK_ACTIONS,
    SCREEN_VIEW_ACTIONS,
} from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const linkAccountWithNumberScreenViewEvent = (
    walletName: string,
    source: string,
    editable: boolean,
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT,
        label: walletName,
        context: JSON.stringify({ source, editable }),
        action: SCREEN_VIEW_ACTIONS.VIEW_LINK_PAYLATER,
    });
};

export const clickProceedLinkPayLaterEvent = (
    walletName: string,
    source: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_PROCEED_LINK_PAYLATER,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const impressionConfirmProceedEvent = (
    walletName: string,
    source: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CONFIRM_PROCEED,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const impressionVerifyProceedEvent = (
    walletName: string,
    source: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_VERIFY_PROCEED,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const impressionResendOtpEvent = (
    walletName: string,
    source: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_RESEND_OTP,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const clickVerifyProceedEvent = (
    walletName: string,
    source: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_VERIFY_PROCEED,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const clickResendOtpEvent = (
    walletName: string,
    source: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_LINK_WALLET_RESEND_OTP,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};
